import React, { Component } from 'react';
import Layout from '../../../Layouts/DefaultLayout';
import { NewsGrid } from '../../../Components';
import { Breadcrumb } from 'react-bootstrap'



class NewsViewContainer extends Component {

    constructor(props) {
        super();
        this.state = {
            year: [],
            month: [],
            bmos: [],
            industries: [],
            partners:[],        //added for partners filter in Resource page    /*Separate Partners from Operators Filter*/
            bridge:[],          //added for bridge filter in Resource page      /*Separate Partners from Operators Filter*/
            bmos_partners:[]    //added for partners filter in Resource page    /*Separate Partners from Operators Filter*/
        }
        document.title = "Bridge Alliance | News"
    }

    componentDidMount = async () => {
        var _this = this;           //added for partners filter in Resource page    /*Separate Partners from Operators Filter*/
        await this.props.setGeneralData();
        this._setData(1);
        this.setPartners(_this);    //added for partners filter in Resource page    /*Separate Partners from Operators Filter*/
    }

    //to fetch partners data    /*Separate Partners from Operators Filter*/
    setPartners = async (_this) => {
        let partnerobj = [];
        let partnersformdata = {
            "posts_per_page": 1000,
            "posts_status": ["publish"]
        }
        await this.props.searchPartnersJson(
            this.props.token, 1, partnersformdata
        );
    }
    /*Separate Partners from Operators Filter*/

    shouldComponentUpdate(nextProps, nextState) {

        return true;
    }

    onPageChange = (pageno) => {
        this._setData(pageno);
    }

    _setData = async (page) => {
        let formdata = {
            "posts_per_page": 16,
            "env": process.env.REACT_APP_MODE,
            "post-type": "news",
            "orderby": "post_modified"
        }
        if (this.state.year.length > 0) {
            formdata["year"] = this.state.year[0];
        } if (this.state.month.length > 0) {
            formdata["month"] = this.state.month[0];
        } if (this.state.bmos.length > 0) {
            /*Separate Partners from Operators Filter*/
            if(this.props.data.selected.selected_bridge.length > 0)
            {
                //check selected bridge value matches bmos value then remove those bridge index
                for(var b=0;b<this.state.bmos.length;b++)
                {
                    for (var i = 0; i < this.props.data.selected.selected_bridge.length; i++) {
                        if(this.state.bmos[b] == this.props.data.selected.selected_bridge[i])
                        {
                            this.state.bmos.splice(b,1);
                        }
                    }
                }
                //this.state.bmos.pop(this.props.data.selected.selected_bridge[0]);
            }
            if(this.props.data.selected.selected_partners.length > 0)
            {
                //check selected partners value matches bmos value then remove those bmos index
                for(var b=0;b<this.state.bmos.length;b++)
                {
                    for (var i = 0; i < this.props.data.selected.selected_partners.length; i++) {
                        if(this.state.bmos[b] == this.props.data.selected.selected_partners[i])
                        {
                            this.state.bmos.splice(b,1);
                        }
                    }
                }
                    
               
                //this.state.bmos.pop(this.props.data.selected.selected_partners);
            }
           
        formdata["bmos"] = this.state.bmos;
    } 
    /*else
    {
        if(this.props.data.selected.selected_bmos.length > 0)
        {
            this.state.bmos.push(this.props.data.selected.selected_bmos[0]);
        }
    }*/
    //added for partners filter in Resource page
    if (this.state.partners.length > 0) {  
        if(this.state.bmos.length > 0){
            //formdata["bmos"].push(this.state.partners[0]);
            for(var p=0; p < this.state.partners.length; p++)
            {
                formdata["bmos"].push(this.state.partners[p]);
            }
            formdata["partners"] = this.state.partners;
        }
        else
        {
            if((formdata["bmos"] != undefined) && (formdata["bmos"].length > 0))
            {
                for(var p=0; p < this.state.partners.length; p++)
                {
                    formdata["bmos"].push(this.state.partners[p]);
                }
                formdata["partners"] = this.state.partners;
            }
            else
            {
                formdata["bmos"] = this.state.partners;
                formdata["partners"] = this.state.partners;
            }
        }
        /*else
        {
            formdata["bmos"] = this.state.partners;
            formdata["partners"] = this.state.partners;
        }*/
    } 
    //added for partners filter in Resource page

     //added for bridge filter in Resource page
     if (this.state.bridge.length > 0) {  
        if(this.state.bmos.length > 0){
            formdata["bmos"].push(this.state.bridge[0]);
            formdata["bridge"] = this.state.bridge;
        }
        else
        {
            if(formdata["bmos"] != undefined)
            {
                formdata["bmos"].push(this.state.bridge[0]);
                formdata["bridge"] = this.state.bridge;
            }
            else
            {
                formdata["bmos"] = this.state.bridge;
                formdata["bridge"] = this.state.bridge;
            }
           
        }
    } 
    //added for bridge filter in Resource page  /*Separate Partners from Operators Filter*/
        
        if (this.state.industries.length > 0) {
            formdata["industries"] = this.state.industries;
        }

        await this.props.searchPostsJson(
            this.props.token, page, formdata
        );
    }

    _convertSelectedDataToArray = (e) => {
        let ar = [];
        e.forEach(function (element) {
            ar.push(element.value);
        });
        return ar;
    }
    _onChangeSelect = (e, type) => {
        this.setState({ [type]: this._convertSelectedDataToArray(e) }, () => {
            this._setData(1)
        });
    }


    render = () => {
        return (
            <Layout className="inner-page">
                <div className="container">
                    {/*
                    <Breadcrumb className="mt-4">
                        <Breadcrumb.Item href="/resources">Resources</Breadcrumb.Item>
                    </Breadcrumb>
                    */}
                    <h1>News</h1>
                    <br/>
                    {(this.props.data !== undefined) && (
                        <NewsGrid
                            industries={this.props.industries}
                            bmos = {this.props.bmos}
                            partners = {this.props.partners.result}     //added for partners filter in Resource page    /*Separate Partners from Operators Filter*/
                            bmos_partners = {this.props.bmos_partners}  //added for partners filter in Resource page    /*Separate Partners from Operators Filter*/
                            bmos_enable                                 //added for new filters display in Resource page    /*Separate Partners from Operators Filter*/
                            //partners_enable                             //added for new filters display in Resource page    /*Separate Partners from Operators Filter*/
                            //bridge_enable                               //added for new filters display in Resource page    /*Separate Partners from Operators Filter*/

                            years
                            months
                            data={this.props.data ? this.props.data.data : []}
                            selectedData={this.props.data.selected || {}}
                            selectedPartnerData = {this.props.partners.selected || {} } //added for partners filter in Resource page    /*Separate Partners from Operators Filter*/
                            onChange={this._onChangeSelect}
                            currentpage={parseInt(this.props.data ? this.props.data.currentpage : 0)}
                            max_num_pages={parseInt(this.props.data ? this.props.data.max_num_pages : 0)}
                            isLoading={this.props.isLoading_posts}
                            posttype={`news`}
                            onPageChange={this.onPageChange}
                        />
                    )}



                </div>
            </Layout>
        );
    };



}


/* Export Component ==================================================================== */
export default NewsViewContainer;